import React from 'react';
import { useNavigationFooter } from './NavigationFooter.hooks';
import {
  NavigationFooterContainer,
  PreviousButton,
  NextButton,
  EmptySpacer,
  SaveDraftButton,
  ButtonsContainer,
} from './NavigationFooter.styles';

export interface NavigationFooterProps {
  currentStep: number;
  isNextDisabled: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onSaveDraft?: () => void;
  editMode?: boolean;
  recordToEdit?: any;
  /** Blocks draft / next while a confirm or draft save is in flight */
  isBusy?: boolean;
}

const NavigationFooter: React.FC<NavigationFooterProps> = ({
  currentStep,
  isNextDisabled,
  onPrevious,
  onNext,
  onSaveDraft,
  editMode = false,
  recordToEdit = null,
  isBusy = false,
}) => {
  const {
    showPreviousButton,
    previousButtonText,
    nextButtonText,
    nextButtonAriaLabel,
    isNextButtonDisabled,
    showSaveDraftButton,
  } = useNavigationFooter({
    currentStep,
    isNextDisabled,
    onPrevious,
    onNext,
    onSaveDraft,
    editMode,
    recordToEdit,
  });

  return (
    <NavigationFooterContainer>
      {showPreviousButton ? (
        <PreviousButton
          variant="tonal"
          onClick={onPrevious}
          aria-label="Previous step"
          disabled={isBusy}
        >
          {previousButtonText}
        </PreviousButton>
      ) : (
        <EmptySpacer />
      )}

      <ButtonsContainer>
        {showSaveDraftButton && onSaveDraft && (
          <SaveDraftButton
            variant="tonal"
            onClick={onSaveDraft}
            aria-label="Save draft"
            disabled={isBusy}
          >
            Guardar Borrador
          </SaveDraftButton>
        )}
        <NextButton
          onClick={onNext}
          disabled={isNextButtonDisabled || isBusy}
          aria-label={nextButtonAriaLabel}
        >
          {nextButtonText}
        </NextButton>
      </ButtonsContainer>
    </NavigationFooterContainer>
  );
};

export default NavigationFooter;
